<template>
  <div class="app">
    <SideMenu v-if="showSidebar && !isMobile" />
    <MobileHeader v-if="showSidebar && isMobile" />
    <main class="main-content" :class="{ 'no-sidebar': !showSidebar, 'mobile': isMobile && showSidebar }">
      <router-view></router-view>
    </main>
  </div>
</template>

<script>
import { inject, computed, ref, onMounted, onUnmounted } from 'vue'
import { useRoute } from 'vue-router'
import SideMenu from './components/SideMenu.vue'
import MobileHeader from './components/MobileHeader.vue'

export default {
  name: 'App',
  components: {
    SideMenu,
    MobileHeader
  },
  setup() {
    const env = inject('env')
    const route = useRoute()
    const isMobile = ref(false)

    const isLoginPage = computed(() => {
      return route.path === '/login' || route.path === '/register' || route.path === '/check-email' || route.path === '/password-reset-failed' || route.path === '/reset-password' || route.meta.noLayout
    })

    const isAdminPage = computed(() => {
      return route.path.startsWith('/admin')
    })

    const isNotFoundPage = computed(() => {
      return route.name === 'NotFound'
    })

    const showSidebar = computed(() => {
      return !isLoginPage.value && !isAdminPage.value && !isNotFoundPage.value
    })

    const checkMobile = () => {
      isMobile.value = window.innerWidth <= 768
    }

    onMounted(() => {
      checkMobile()
      window.addEventListener('resize', checkMobile)
    })

    onUnmounted(() => {
      window.removeEventListener('resize', checkMobile)
    })

    return {
      env,
      isLoginPage,
      isAdminPage,
      isNotFoundPage,
      showSidebar,
      isMobile
    }
  }
}
</script>

<style>
.app {
  font-family: 'IBM Plex Sans', Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: var(--text-primary);
  background-color: var(--bg-primary);
  min-height: 100vh;
}

.main-content {
  margin-left: 199px; /* Width of side menu */
  padding: 20px;
  background-color: var(--bg-primary);
  min-height: 100vh;
  transition: margin-left 0.3s ease;
}

.main-content.no-sidebar {
  margin-left: 0;
}

.main-content.mobile {
  margin-left: 0;
  padding: 80px 20px 20px 20px; /* Add top padding for mobile header */
}

@media (max-width: 768px) {
  .main-content {
    margin-left: 0;
    padding: 80px 20px 20px 20px;
  }

  .main-content.no-sidebar {
    padding: 20px;
  }
}
</style>